import React, { useState } from "react";
import { motion } from "framer-motion";
import { REVEAL } from "@/lib/motion";
import { AuditCta } from "@/components/AuditCta";

const formatSgd = (value) => `S$${value.toLocaleString("en-SG")}`;

export const HomeCalculator = () => {
  const [sdrs, setSdrs] = useState(2);
  const [monthly, setMonthly] = useState("4000");

  const monthlyValue = Number(monthly) || 0;
  const yearly = sdrs * monthlyValue * 12;

  return (
    <section className="px-6 sm:px-8 pb-20 sm:pb-28" data-testid="home-calculator">
      <div className="max-w-5xl mx-auto">
        <motion.h2 {...REVEAL} className="font-fraunces font-extrabold text-3xl sm:text-4xl tracking-tight text-[#1F1F1C]">
          What does manual outbound cost you?
        </motion.h2>

        <div className="mt-10 grid md:grid-cols-2 gap-5">
          <div className="bg-[#EADCC6] rounded-2xl border border-[#1F1F1C]/10 p-7 sm:p-9">
            <label htmlFor="sdr-count" className="block text-xs font-semibold text-[#4A463F] uppercase tracking-[0.14em]">
              Number of SDRs
            </label>
            <div className="mt-4 flex items-center gap-5">
              <input
                id="sdr-count"
                type="range"
                min="0"
                max="10"
                step="1"
                value={sdrs}
                onChange={(e) => setSdrs(Number(e.target.value))}
                className="flex-1 accent-[#C8703A]"
                data-testid="calculator-sdr-slider"
              />
              <span className="font-fraunces font-extrabold text-2xl text-[#1F1F1C] w-10 text-right" data-testid="calculator-sdr-value">
                {sdrs}
              </span>
            </div>

            <label htmlFor="sdr-cost" className="mt-9 block text-xs font-semibold text-[#4A463F] uppercase tracking-[0.14em]">
              Monthly cost per SDR (SGD)
            </label>
            <input
              id="sdr-cost"
              type="number"
              min="0"
              step="100"
              value={monthly}
              onChange={(e) => setMonthly(e.target.value)}
              className="mt-4 w-full bg-[#F4E9D8] border border-[#1F1F1C]/20 rounded-2xl px-4 py-3 text-[#1F1F1C] text-sm focus:border-[#C8703A] focus:ring-2 focus:ring-[#C8703A]/20 focus:outline-none"
              data-testid="calculator-cost-input"
            />

            <div className="mt-9 pt-7 border-t border-[#1F1F1C]/10">
              <p className="text-xs font-semibold text-[#4A463F] uppercase tracking-[0.14em]">Yearly cost</p>
              <p className="mt-3 font-fraunces font-extrabold text-4xl sm:text-5xl text-[#1F1F1C]" data-testid="calculator-yearly-cost">
                {formatSgd(yearly)}
              </p>
              <p className="mt-3 text-xs text-[#4A463F]">
                {sdrs} {sdrs === 1 ? "SDR" : "SDRs"} x {formatSgd(monthlyValue)} a month x 12 months.
              </p>
            </div>
          </div>

          <div className="bg-[#3D472D] rounded-2xl p-7 sm:p-9 flex flex-col justify-center" data-testid="calculator-offer">
            <p className="text-xs uppercase tracking-[0.18em] font-semibold text-[#C8703A]">Outbound Engine Build</p>
            <p className="mt-5 font-fraunces font-extrabold text-4xl sm:text-5xl text-[#F4E9D8]">S$3,000</p>
            <p className="mt-4 text-sm md:text-base text-[#F4E9D8]/75 leading-relaxed">
              One-off, live in 2 weeks. Built in your own accounts, in your name.
            </p>
            <div className="mt-9">
              <AuditCta variant="onDark" testId="calculator-cta" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeCalculator;
